import moment from "moment-timezone";

export default (val, format) => {
  return moment.utc(val).tz(process.env.VUE_APP_TIME_ZONE).format(format);
}